import { Timestamp, collection, doc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { FaqGroupToUpdate } from "../types";

type Params = {
  faqGroupData: FaqGroupToUpdate;
  faqGroupId: string;
};

export const updateFaqGroup = async ({
  faqGroupData,
  faqGroupId,
}: Params): Promise<void> => {
  const collectionRef = collection(db, "faqGroups");
  await updateDoc(doc(collectionRef, faqGroupId), {
    ...faqGroupData,
    updatedAt: Timestamp.now(),
  });
};
